import fitty from "fitty";

fitty.observeWindowDelay = 16;

async function applyFitty() {
  await document.fonts.ready;
  document.querySelectorAll("[data-fitty]").forEach((elem) =>
    fitty(elem, {
      maxSize: elem.dataset.fitty,
      observeMutations: false,
    }),
  );
}
void applyFitty();
